module.exports = __webpack_public_path__ + "img/icon356.38a8ae23.png";